<template>
  <v-card>
    <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
      <h2 style="color:white">Voeg een nieuwe Journey toe</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeNewJourneyDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert
      class="ma-0 pa-1"
      v-if="feedback"
      :value="true"
      type="warning"
    >
    {{ feedback }} 
    </v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form  ref="AddJourneyForm" lazy-validation>
        <v-text-field
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          hide-details
          label="Naam Customer Journey"
          v-model.trim="newJourney.name"
          autocomplete
          background-color="background"  
          prepend-inner-icon="label"
          required
        ></v-text-field>
        <v-text-field
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          background-color="background"
          label="Omschrijving"
          v-model.trim="newJourney.description"
          autocomplete
          hint="Vul een korte omschrijving in van deze  Journey"
          prepend-inner-icon="info"
          persistent-hint
          required
        ></v-text-field>
        <v-select
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          background-color="background"
          :items="journeyTypes"
          item-text="name"
          item-value="id"
          prepend-inner-icon="how_to_vote"
          v-model="newJourney.type"
          label="Type journey"
          v-on:input="checkJourneyType()"
          hide-details
          >
        </v-select>
        <v-select
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          :item-color="companyPrimaryColor"
          background-color="background"
          :items="languages"
          item-text="name"
          item-value="code"
          prepend-inner-icon="flag"
          v-model="newJourney.selectedLanguages"
          multiple
          label="Selecteert talen"
          hide-details
          >
        </v-select>
        <v-select
          class="mt-2"
          outlined
          :color="companyPrimaryColor"
          background-color="background" 
          :item-color="companyPrimaryColor"
          v-if="newJourney.type == 'global'"
          :items="companies"
          item-text="name"
          item-value="id"
          prepend-inner-icon="business"
          v-model="journeyCompanies"
          v-on:input="checkJourneyType()"
          label="Select onderneming"
          multiple
          hide-details
          >
        </v-select>

        <v-select
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          :item-color="companyPrimaryColor"
          hide-details
          background-color="background"
          :items="filterTypes"
          item-text="name"
          item-value="id"
          prepend-inner-icon="mdi-form-select"
          v-model="newJourney.filter"
          @change="filterSelected()"
          label="Gebruiken voor specifieke behandelingen"
          >
        </v-select>

        <div v-if="newJourney.filter && newJourney.filter != 'none'" class="pa-4 ma-4 ml-5 mr-0 ext-center" style="background-color: #f6f7fb">
          <p><strong>Geef de extacte naam van de behandeling op per regel.</strong></p>
          <div v-for="(field, index) in newJourney.filterFields" :key="index + changes">
            <v-text-field
              v-if="index == 0"
              class="mt-3"
              outlined
              :color="companyPrimaryColor"
              hide-details
              dense
              label="Naam behandeling"
              v-model="newJourney.filterFields[index]"
              append-outer-icon="mdi-bbr"
              background-color="menu"
            ></v-text-field>
            <v-text-field
              v-else
              class="mt-3"
              outlined
              :color="companyPrimaryColor"
              hide-details
              dense
              label="Naam behandeling"
              v-model="newJourney.filterFields[index]"
              background-color="menu"
              append-outer-icon="mdi-close"
              @click:append-outer="removeFilterField(index)"
            ></v-text-field>
          </div>
          <div class="text-center ma-2">
            <v-btn small fab dark :color="companyPrimaryColor" @click="newFilterField()">
              <v-icon darken>add</v-icon>
            </v-btn>
          </div>
        </div>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeNewJourneyDialog()"
              >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              dark
              rounded
              :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
              :color="companySecondaryColor"
              @click="addJourney()"
              >
              Journey toevoegen
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>

  </v-card>
</template>


<script>
import { bus } from "../../main";
import db from "../../firebase/init";
import firebase from "firebase/app";;

export default {
  name: "add-journey-form",
  props: {
    companies: Array,
    activeComp: Object
  },

  data() {
    return {
      newJourney: {
        type: "business",
        selectedLanguages: [],
        name: null,
        description: null,
        filter: 'none',
        filterFields: new Array()
        
      },
      journeyTypes: [
        {
          name: "Algemeen",
          id: "global"
        },
        {
          name: "Individueel",
          id: "business"
        }
      ],
      filterTypes: [
        {
          name: "Versturen na alle behandelingen",
          id: "none"
        },
        {
          name: "Versturen na specifieke behandelingen",
          id: "include"
        },
        {
          name: "Specifieke behandelingen uitsluiten",
          id: "exclude"
        }
      ],
      feedback: null,
      journeyCompanies: [],
      journeyCompaniesBoolean: {},
      changes: 0
    };
  },

  created() {
    bus.$on("getActiveComp", this.resetJourneyModal);
  },

  methods: {
    closeNewJourneyDialog(){
      this.$emit("newJourneyDialogChange", false);
      this.newJourney.name = null;
      this.newJourney.description = null;
      this.newJourney.type = "business";
      
      this.newJourney.selectedLanguages = [];
      this.journeyCompanies = [];
    },

    filterSelected(){
      this.newJourney.filterFields = ['']
      this.changes++
    },

    removeFilterField(index){
      this.newJourney.filterFields.splice(index,1);
      this.changes++
    },

    newFilterField(){
      this.newJourney.filterFields.push('');
      this.changes++
    },

    resetJourneyModal() {
      console.log("resetJourneyModal");
      this.newJourney.type = "business";
      this.journeyCompanies = [];
      this.checkJourneyType();
    },

    checkJourneyType() {
      this.journeyCompaniesBoolean = {};
      let journeyCompaniesArray = this.journeyCompanies;

      let company = this.activeComp.id;
      if (this.newJourney.type == "business") {
        this.journeyCompaniesBoolean[company] = true;
      } else {
        journeyCompaniesArray.forEach(company => {
          this.journeyCompaniesBoolean[company] = true;
        });
      }
    },

    addJourney() {
      this.checkJourneyType()
      if (this.newJourney.name && this.newJourney.description && this.newJourney.type) {
        db.collection("journeys")
          .add({
            name: this.newJourney.name,
            description: this.newJourney.description,
            companies: this.journeyCompaniesBoolean,
            selectedLanguages: this.newJourney.selectedLanguages,
            type: this.newJourney.type
          })
          .then(() => {
            db.collection("log")
              .add({
                time: new Date(),
                logType: "info",
                user: this.userFirstName + " " + this.userLastName,
                userType: this.userRole,
                company: this.userCompany,
                actionType: "User Action",
                action: "Nieuwe Journey toegevoegd: " + this.activeComp.ame,
                extra:
                  "<b>Naam:</b> " +
                  this.newJourney.name +
                  "<br>" +
                  "<b>Omschrijving:</b> " +
                  this.newJourney.description +
                  "<br>" +
                  "<b>Type:</b> " +
                  this.newJourney.type +
                  "<br>" +
                  "<b>Talen:</b> " +
                  this.newJourney.selectedLanguages +
                  "<br>" +
                  "<b>Bedrijven:</b> " +
                  this.journeyCompaniesBoolean
              })
              .catch(error => {
                console.error("Error logging new branch: ", error);
              });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeNewJourneyDialog();
            this.$refs.AddJourneyForm.reset();
          })
          .catch(error => {
            console.error("Error adding Journey: ", error);
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Error adding Journey: " + this.activeComp.name,
              extra: JSON.stringify(error)
            });
          });
      } else {
        this.feedback = "Vul alle velden in om een Journey toe te voegen";
      }
    }
  },

  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    languages() {
      let activeLanguages = [];
      if (this.activeComp.languages) {
        this.activeComp.languages.forEach(language => {
          let activeLanguage = {};
          if (language == "nl") {
            activeLanguage.code = "nl";
            activeLanguage.name = "Nederlands";
            activeLanguages.push(activeLanguage);
          } else if (language == "en") {
            activeLanguage.code = "en";
            activeLanguage.name = "Engels";
            activeLanguages.push(activeLanguage);
          }
        });

        return activeLanguages;
      } else {
        return activeLanguages;
      }
    }
  }
};
</script>

